// Fact Find: freshness. The fact finds of the book that fall due for renewal,
// on the Desk Dashboard (`wealth.onboarding.fact-find.freshness`, ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const FactFindRenewalsCard = lazy(() =>
    import('./fact-find-freshness.slots').then((m) => ({ default: m.FactFindRenewalsCard })),
);

export default defineWebFeature({
    id: 'wealth.onboarding.fact-find.freshness',
    slots: {
        'desk.dashboard.cards': [
            {
                key: 'fact-find-renewals',
                order: 40,
                span: 6,
                rows: 2,
                title: 'Fact finds for renewal',
                summary: 'The fact finds of your book that fall due for renewal.',
                href: '/desk/fact-find',
                countLabel: (n) => `${n} due`,
                emptyBehaviour: 'collapse',
                count: (ctx) =>
                    ctx.overview
                        ? (ctx.overview.factFindRenewals ?? []).filter((r) =>
                              ctx.keepClient(r.clientId),
                          ).length
                        : null,
                Component: FactFindRenewalsCard,
            },
        ],
    },
});
